<template>
  <a-drawer :title="drawerTitle" :mask-closable="false" :width="900" :visible="visible" @close="onClose">
    <a-spin :spinning="spinning">
      <a-form-model ref="form" class="basic-form" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="标题" prop="title">
              <a-input ref="title" v-model="form.title" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="故障等级" prop="level">
              <a-select v-model="form.level" placeholder="请选择故障等级">
                <a-select-option v-for="(item, index) in faultLevels" :key="index" :value="item.value">
                  <a-tag :color="item.color"> {{ item.label }} </a-tag>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="关联业务域" prop="domains">
              <a-select v-model="form.domains" mode="multiple" :max-tag-count="3" show-search placeholder="请选择关联业务域">
                <a-select-option v-for="item in domainData" :key="item.id" :value="item.id">{{ item.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="上报时间" prop="reported_time">
              <a-date-picker v-model="form.reported_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="关联项目" prop="projects">
              <a-select v-model="form.projects" mode="multiple" :max-tag-count="2" show-search placeholder="请选择关联项目" :filter-option="utils.filterOption">
                <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="开始时间" prop="started_time">
              <a-date-picker v-model="form.started_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="解决时间" prop="resolved_time">
              <a-date-picker v-model="form.resolved_time" style="width: 100%" show-time value-format="YYYY-MM-DD HH:mm:ss" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="故障标签" prop="tags">
              <a-select v-model="form.tags" mode="multiple" :max-tag-count="5" placeholder="请选择故障标签">
                <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="复盘状态" prop="tags">
              <a-select v-model="form.recap_status" placeholder="请选择复盘状态">
                <a-select-option v-for="(item, index) in faultRecapStatus" :key="index" :value="item.value">
                  <a-tag :color="item.color"> {{ item.label }} </a-tag>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="复盘组织人" prop="tags">
              <a-select v-model="form.recap_organizer" placeholder="请选择复盘组织人" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, key) in userData" :key="key" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="复盘参与人" prop="tags">
              <a-select v-model="form.recap_players" mode="multiple" placeholder="请选择复盘参与人" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, key) in userData" :key="key" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="责任划分">
              <a-form-model class="duty-form" layout="horizontal">
                <a-row v-for="(item, index) in dutyForm" :key="index">
                  <a-col :span="5">
                    <a-form-model-item label="责任人" :label-col="{ span: 8 }" :wrapper-col="{ span: 15 }">
                      <!-- <a-select v-model="item.user_id" placeholder="责任人" show-search :filter-option="utils.filterOption">
                        <a-select-option v-for="(user, key) in userData" :key="key" :value="user.id">{{ user.nickname }} </a-select-option>
                      </a-select> -->
                      <user-select v-model="item.user_id" show-search :show-all="false" :project-id="0" placeholder="责任人" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="4">
                    <a-form-model-item label="扣除分数" :label-col="{ span: 11 }" :wrapper-col="{ span: 12 }">
                      <a-input-number v-model="item.score" placeholder="扣除分数" :min="0" :max="100" style="width: 72px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="4">
                    <a-form-model-item label="占比" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                      <a-input-number v-model="item.ratio" placeholder="占比" :min="0" :max="100" style="width: 72px" />
                      <span> %</span>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="10">
                    <a-form-model-item label="描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                      <a-textarea v-model="item.description" placeholder="描述" auto-size />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="1">
                    <a class="duty-delete" @click="onDelete(index)"><a-icon type="delete" /></a>
                  </a-col>
                </a-row>
                <a class="duty-add" @click="onAdd"><a-icon type="plus" /> 添加</a>
              </a-form-model>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="故障描述">
              <vditor-editor v-model="form.content" :height="200" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.attribution" :span="24">
            <a-form-model-item label="归因分析">
              <vditor-editor v-model="form.attribution" :height="600" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div style="height: 100px" />
      </a-form-model>
    </a-spin>
    <div class="drawer-action">
      <a-button :style="{ marginRight: '8px' }" @click="onClose"> 取消 </a-button>
      <a-button type="primary" :loading="loading" @click="onSubmit()"> 提交 </a-button>
    </div>
  </a-drawer>
</template>
<script>
import { tagList } from '@/api/system/tag';
import { userRoleList } from '@/api/system/auth';
import { projectList } from '@/api/project/project';
import { domainBasicList } from '@/api/system/domain';
import { faultLevels, faultRecapStatus } from '@/utils/dictionary';
import { faultDetail, faultAdd, faultModify } from '@/api/event/fault';

import UserSelect from '@/components/User/UserSelect';
import VditorEditor from '@/components/VditorEditor';

export default {
  components: { VditorEditor, UserSelect },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      faultLevels,
      faultRecapStatus,
      visible: false,
      loading: false,
      spinning: false,
      tagData: [],
      dutyForm: [],
      projects: [],
      userData: [],
      domainData: [],
      form: {
        title: null,
        tags: [],
        projects: [],
        domains: [],
        attribution: ''
      },
      rules: {
        title: [{ required: true, message: '故障标题不能为空', trigger: 'blur' }],
        level: [{ required: true, message: '故障等级不能为空', trigger: 'blur' }],
        domains: [{ required: true, message: '关联业务域不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '描述内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    drawerTitle() {
      return `${this.sourceId === null ? '添加' : '编辑'}故障`;
    }
  },
  watch: {
    display() {
      this.visible = this.display;
      this.getProjectList();
      this.getDomainList();
      this.getTagList();
      this.getUserList();
      if (this.visible === true) {
        if (this.sourceId !== null) {
          this.getFaultDetail();
        } else {
          this.dutyForm = [];
          this.onAdd();
          this.form = {
            title: null,
            tags: [],
            projects: [],
            domains: []
            // attribution: '## 处理过程\nxx\n## 故障原因\nxx\n## 根因分析\nxx\n## 定级依据\nxx\n## 改进措施\nxx\n'
          };
        }
      }
    }
  },
  methods: {
    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    // 获取业务域列表
    getDomainList() {
      domainBasicList({}).then(res => {
        this.domainData = res.data.items;
      });
    },

    // 获取标签列表
    getTagList() {
      tagList({ group_code: 'fault' }).then(res => {
        this.tagData = res.data.items;
      });
    },

    // 获取用户列表
    getUserList() {
      userRoleList({ project_id: 1 }).then(res => {
        this.userData = res.data.items;
      });
    },

    // 获取故障详情
    getFaultDetail() {
      this.spinning = true;
      this.form = {};
      faultDetail({ id: this.sourceId }).then(res => {
        const data = res.data;
        this.form = {
          title: data.title,
          level: data.level,
          projects: data.projects.map(p => {
            return p.id;
          }),
          domains: data.domains.map(d => {
            return d.id;
          }),
          tags: data.tags.map(t => {
            return t.id;
          }),
          recap_players: data.recap_players.map(p => {
            return p.id;
          }),
          recap_status: data.recap_status,
          recap_organizer: data.recap_organizer.id,
          reported_time: data.reported_time,
          started_time: data.started_time,
          resolved_time: data.resolved_time,
          attribution: data.attribution,
          content: data.content,
          enclosure: data.enclosure
        };
        this.dutyForm = data.duty.map(item => {
          return {
            id: item.id,
            user_id: item.user.id,
            score: item.score,
            ratio: item.ratio,
            description: item.description
          };
        });
        if (this.dutyForm.length === 0) {
          this.onAdd();
        }
        this.spinning = false;
      });
    },

    onDelete(index) {
      this.dutyForm.splice(index, 1);
    },
    onAdd() {
      this.dutyForm.push({
        user_id: null,
        score: 0,
        ratio: 0,
        description: null
      });
    },

    // 点击提交
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.sourceId === null) {
            // 添加故障
            faultAdd({ ...this.form, duties: this.dutyForm, problem_id: this.problemId })
              .then(() => {
                this.onClose('submit');
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            // 编辑故障
            faultModify({ id: this.sourceId, ...this.form, duties: this.dutyForm })
              .then(() => {
                this.onClose('submit');
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    onClose(type) {
      this.$emit('close', type);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.basic-form {
  .ant-form-item {
    margin-bottom: 0;
    .ant-form-item-label {
      line-height: 32px;
    }
  }
}
/deep/.duty-form {
  .ant-form-item {
    .ant-form-item-label {
      line-height: 39.9999px;
    }
  }
}

.drawer-action {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
.duty-delete {
  line-height: 39.99px;
  padding: 8px;
  font-size: 16px;
}
</style>
